<template>
  <VPopup
      class="order-position-code-info-popup"
      :target="target"
      :visible="true"
      show-pointer
      align="left"
  >
    <dl>
      <dt>Название товара:</dt>
      <dd>{{ position?.product?.name }}</dd>

      <dt>Название по док.:</dt>
      <dd>{{ position?.name }}</dd>

      <dt>Категория:</dt>
      <dd>{{ position?.productCategory?.name }}</dd>

      <dt>Арт. покупателя:</dt>
      <dd>{{ position?.buyersCode || '--' }}</dd>

      <dt>Арт. поставщика:</dt>
      <dd>{{ position?.sellersCode || '--' }}</dd>
    </dl>
  </VPopup>
</template>

<style lang="scss" src="./OrderPositionCodeInfoPopup.scss" />

<script lang="ts">
import type OrderPosition from '@/domains/Orders/OrderPosition';

export default defineComponent({
  name: 'OrderPositionCodeInfoPopup',

  props: {
    position: {
      type: Object as PropType<OrderPosition>,
      default: null,
    },
    target: {
      type: HTMLElement,
      default: null,
    },
  },
});
</script>
